module.exports = __webpack_public_path__ + "img/location_disable.40368f55.png";